module.exports = __webpack_public_path__ + "static/media/course2.54268a0c.png";